import { getCrmBackendOrigin, usesDevProxy } from '@/config/backend';
import { BUILD_ENV } from '@/config/build-env';
/** SockJS path on CRM backend (STOMP endpoint). Default matches Spring `/websocket/app`. */
export const DEFAULT_CHAT_SOCKJS_PATH = '/websocket/app';
function envFlagIsTrue(value) {
    return value === '1' || value.toLowerCase() === 'true';
}
/**
 * When `false`, SockJS connects to `getCrmBackendOrigin()` + `CHAT_SOCKJS_PATH`.
 * When `true`, uses same-origin `/websocket/...` (webpack dev-server or nginx proxy + `access_token`).
 */
export function usesCrmChatSameOriginProxy() {
    if (envFlagIsTrue(BUILD_ENV.CHAT_CROSS_ORIGIN)) {
        return false;
    }
    if (BUILD_ENV.CHAT_CROSS_ORIGIN === '0' || BUILD_ENV.CHAT_CROSS_ORIGIN.toLowerCase() === 'false') {
        return true;
    }
    if (usesDevProxy()) {
        return true;
    }
    return !getCrmBackendOrigin();
}
export function getChatSockJsPath() {
    const path = BUILD_ENV.CHAT_SOCKJS_PATH || DEFAULT_CHAT_SOCKJS_PATH;
    return path.startsWith('/') ? path : `/${path}`;
}
/**
 * SockJS URL for STOMP.
 * - `USE_DEV_PROXY=1` → `/websocket/app` on UI origin (webpack/nginx proxy)
 * - otherwise → `CRM_BACKEND_URL` + `/websocket/app`
 */
export function getCrmChatSockJsUrl() {
    const path = getChatSockJsPath();
    if (usesCrmChatSameOriginProxy()) {
        return path;
    }
    const origin = getCrmBackendOrigin();
    if (!origin) {
        return path;
    }
    return `${origin.replace(/\/$/, '')}${path}`;
}
